<template>
    <div class="my-item">
        <div class="custom-wrap">
            <Form ref="form" :model="form" :label-width="120" :rules="ruleValidate">
                <FormItem label="用户名:" prop="userName">
                    <Input v-model="form.userName" placeholder="请输入用户名" style="width: 600px" autocomplete='new-password'></Input><span @click="lookBalance" class="yue">查询余额</span>
                </FormItem>
                <FormItem label="密码:" prop="password">
                    <Input type="password" v-model="form.password" placeholder="请输入密码" style="width: 600px" autocomplete='new-password'></Input>
                </FormItem>
                <FormItem label="签名:" prop="sign">
                    <Input v-model="form.sign" placeholder="请输入签名" style="width: 600px" autocomplete='new-password'></Input>
                </FormItem>
                <FormItem>
                    <Button type="primary" @click="handleSubmit('form')" :loading="modal_loading">保存</Button>
                </FormItem>
            </Form>
        </div>
        <iModal
                title="短信余额"
                @on-cancel="visible=false"
                v-model="visible"
                class-name="audience-info-modal"
                width="520"
        >
            <div class="model_con">
                <p>账号：{{form.userName}}</p>
                <p>当前余额为：{{balance}}</p>
            </div>
        </iModal>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        name: "host-common-messageAccount",

        data() {
            return {
                form:{
                    userName:'',
                    password:'',
                    sign:''
                },
                visible:false,
                modal_loading:false,
                balance:0,
                balanceId:"",
                ruleValidate: {
                    userName: [
                        { required: true, message: "用户名不能为空", trigger: "blur" },
                    ],
                    password: [
                        { required: true, message: "密码不能为空", trigger: "blur" },
                    ],
                    sign: [
                        { required: true, message: "签名不能为空", trigger: "blur" },
                    ],
                },
            };
        },
        computed: {
            ...mapGetters({
                //hostId: "getHostId",
                exhibitionId: "getExhibitionId",
            }),

        },
        created() {
            this.init();
        },
        components: {
        },
        methods: {
            ...mapActions({
                getSmsAccount:"getSmsAccount",
                SmsAccountSave:"SmsAccountSave",
                getHostSmsMargin:"getHostSmsMargin"
            }),
            async init() {
                let res=await this.getSmsAccount()
                console.log(res)
                this.form={
                    userName:res.userName||'',
                    password:res.password||'',
                    sign:res.sign,
                }
                this.balanceId=res.id

            },
            // 验证表单
            validForm(name) {
                return new Promise((resolve, reject) => {
                    this.$refs[name].validate(valid => {
                        resolve(valid);
                    });
                });
            },
            async handleSubmit(name){

                let valid = await this.validForm(name);
                if (!valid) return;
                this.modal_loading = true;
                let opt={
                    hostId:this.balanceId,
                    userName:this.form.userName,
                    password:this.form.password,
                    sign:this.form.sign
                }
                let res= await this.SmsAccountSave(opt);
                console.log(res)
                if(res&&res.successed){
                    this.$Message.success('保存成功');
                }else{
                    this.$Message.error(res.message)
                }
                this.modal_loading = false;
            },
            async lookBalance(){
                let opt={
                    id:this.balanceId
                }
                let res= await this.getHostSmsMargin(opt);
                console.log(res,'213');
                if(res&&res!=-1){
                    this.balance=res;
                    this.visible=true;
                }else{
                    this.$Message.error('查询失败');
                    this.balance=0
                }
            },
        },
    }
</script>

<style scoped lang="scss">
    .custom-wrap{
        min-height: 600px;
        background: #fff;
        min-width: 1200px;
        padding-top:40px;
    .yue{
        margin-left: 5px;
        cursor: pointer;
        color: #1890ff;
        -webkit-user-select:none ;
        -moz-user-select:none;
    }
    }
</style>
